<form class="card mt-2">
  <div class="card-body">
    <div class="float-right" *ngIf="canViewPto">
      <button type="button" routerLink="/timeoff/pto/manage" class="btn btn-secondary" style="margin-right: 5px;">Manage PTO</button>
      <button type="button" routerLink="/timeoff/ptoSummary" class="btn btn-secondary">PTO Summary</button>
    </div>
    <h2 class="mb-3">Manage Time Off</h2>
    <div class="mb-3">

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Campus:</h5>
        </div>
        <div class="col-10">
          <i *ngIf="!campusList" class="material-icons rotate text-muted">loop</i>
          <p-select styleClass="app-select ml-2 w-100 mb-2" [options]="campusList" [(ngModel)]="campusId" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-select>
        </div>
      </div>      

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Employee:</h5>
        </div>
        <div class="col-10">                    
          <div class="ml-2 w-100 mb-2">
            <p-autoComplete  [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}" [(ngModel)]="selectedUserEmployee"
                            [suggestions]="userList" (completeMethod)="getStaffList($event)" field="name" dataKey="id"
                            [ngModelOptions]="{standalone: true}" [minLength]="1" [autoHighlight]="true"
                            (onSelect)="reloadListAfterStaffChage($event)" [forceSelection]="true"
                            (onClear)="reloadListAfterClear($event)"></p-autoComplete>
          </div>
        </div>
      </div>      

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Status:</h5>
        </div>
        <div class="col-10">
          <i *ngIf="!statusList" class="material-icons rotate text-muted">loop</i>
          <p-select styleClass="app-select ml-2 w-100 mb-2" [options]="statusList" [(ngModel)]="statusId" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-select>
        </div>
      </div>

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>From Date:</h5>
        </div>
        <div class="col-10">
          <input type="date" class="form-control ml-2 w-100 mb-2" [(ngModel)]="startDate" (blur)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}" />
        </div>
      </div>

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>To Date:</h5>
        </div>
        <div class="col-10">
          <input type="date" class="form-control ml-2 w-100 mb-2" [(ngModel)]="endDate" (blur)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}" />
        </div>
      </div>
    </div>

    <div class="mb-3">
      <button *ngIf="canEdit" (click)="newTimeOffRequest()" class="btn btn-secondary">New Time Off Request</button>
    </div>

    <div class="border-top pt-3 mb-3" *ngIf="canManageClosedPeriods">
      <button type="button" class="btn btn-link p-0 d-flex align-items-center" (click)="toggleClosedPeriods()"
              [attr.aria-expanded]="!closedPeriodsCollapsed" aria-controls="closedRequestPeriods">
        <i class="fas mr-2" [ngClass]="closedPeriodsCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
        <span class="font-weight-bold">Closed Request Periods</span>
      </button>
      <div id="closedRequestPeriods" *ngIf="!closedPeriodsCollapsed" class="mt-2">
      <div class="row">
        <div class="col-12 col-lg-2">
          <label>Campus</label>
          <p-select styleClass="app-select w-100 mb-2" [options]="closedPeriodCampusList" [(ngModel)]="closedPeriodForm.programId" [ngModelOptions]="{standalone: true}"></p-select>
        </div>
        <div class="col-6 col-lg-2">
          <label>Start Date</label>
          <input type="date" class="form-control mb-2" [(ngModel)]="closedPeriodForm.startDateString" [ngModelOptions]="{standalone: true}" />
        </div>
        <div class="col-6 col-lg-2">
          <label>End Date</label>
          <input type="date" class="form-control mb-2" [(ngModel)]="closedPeriodForm.endDateString" [ngModelOptions]="{standalone: true}" />
        </div>
        <div class="col-12 col-lg-1">
          <label>Active</label>
          <div class="mt-2">
            <p-checkbox [binary]="true" inputId="closedPeriodActive" [(ngModel)]="closedPeriodForm.isActive" [ngModelOptions]="{standalone: true}"></p-checkbox>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <label>Warning Message</label>
          <textarea class="form-control mb-2" rows="2" [(ngModel)]="closedPeriodForm.message" [ngModelOptions]="{standalone: true}"></textarea>
        </div>
        <div class="col-12 col-lg-2 d-flex align-items-end mb-2">
          <button type="button" class="btn btn-primary mr-2" (click)="saveClosedPeriod()" [disabled]="savingClosedPeriod">Save</button>
          <button type="button" class="btn btn-secondary" *ngIf="closedPeriodForm.timeOffClosedPeriodId > 0" (click)="cancelClosedPeriodEdit()">Cancel</button>
        </div>
      </div>
      <i [hidden]="!loadingClosedPeriods" class="material-icons rotate text-muted">loop</i>
      <div class="text-muted mt-2" *ngIf="!loadingClosedPeriods && filteredClosedPeriods.length === 0">
        No closed request periods match the selected campus and date range.
      </div>
      <table class="table table-sm mt-2" *ngIf="filteredClosedPeriods.length">
        <thead>
          <tr>
            <th>Campus</th>
            <th>Date Range</th>
            <th>Message</th>
            <th>Status</th>
            <th width="110px">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let period of filteredClosedPeriods">
            <td>{{period.programName}}</td>
            <td>{{period.startDate | date: 'MM/dd/yyyy'}} - {{period.endDate | date: 'MM/dd/yyyy'}}</td>
            <td class="small-font">{{period.message}}</td>
            <td>{{period.isActive ? 'Active' : 'Inactive'}}</td>
            <td>
              <button type="button" class="btn btn-link mr-1" (click)="editClosedPeriod(period)" title="Edit Closed Period">
                <i class="fas fa-edit"></i>
              </button>
              <button type="button" class="btn btn-link text-danger" (click)="removeClosedPeriod(period)" title="Remove Closed Period">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>

    <i [hidden]="!loadingList" class="material-icons rotate text-muted">loop</i>
    <p-table #myTable [value]="timeOffList?.result" [responsive]="true" [paginator]="true" [rows]="20"
             [totalRecords]="timeOffList?.totalRecords" [lazy]="true" (onLazyLoad)="reloadFilter($event)">
      <ng-template pTemplate="header">
        <tr>
          <th width="100px"></th>
          <th [pSortableColumn]="'EmployeeName'">Employee<p-sortIcon [field]="'EmployeeName'"></p-sortIcon></th>
          <th [pSortableColumn]="'DateRange'">Date Range<p-sortIcon [field]="'DateRange'"></p-sortIcon></th>
          <th [pSortableColumn]="'TimeRange'">Time Range<p-sortIcon [field]="'TimeRange'"></p-sortIcon></th>
          <th [pSortableColumn]="'Comments'">Comments<p-sortIcon [field]="'Comments'"></p-sortIcon></th>
          <th width="11%"[pSortableColumn]="'ApproverComments'">Approver Comments<p-sortIcon [field]="'ApproverComments'"></p-sortIcon></th>
          <th [pSortableColumn]="'LastModified'">Last Modified<p-sortIcon [field]="'LastModified'"></p-sortIcon></th>
          <th width="11%" [pSortableColumn]="'Changes'">Recent Changes<p-sortIcon [field]="'Changes'"></p-sortIcon></th>
          <th [pSortableColumn]="'DateSubmitted'">Date Submitted<p-sortIcon [field]="'DateSubmitted'"></p-sortIcon></th>
          <th width="5.5%" [pSortableColumn]="'Status'">Status<p-sortIcon [field]="'Status'"></p-sortIcon></th>
          <th>Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <button class="btn btn-secondary mr-2" *ngIf="canEdit && item.canEditRequest" (click)="editTimeOffRequest(item)" title="Edit Time Off">
              <i class="fas fa-edit"></i>
            </button>
          </td>
          <td>
            <span class="ui-column-title">Employee Name</span>            
            {{item.employeeName}}
          </td>
          <td class="small-font">
            <span class="ui-column-title small-font">Date Range</span>
            {{item.startDate | date: 'MM/dd/yyyy'}} - {{item.endDate | date: 'MM/dd/yyyy'}}
          </td>
          <td>
            <span class="ui-column-title">Time Range</span>
            <span *ngIf="item.allDay">All Day</span>
            <span *ngIf="item.allDay == false">{{item.startTime | date: 'shortTime'}} - {{item.endTime | date: 'shortTime'}}</span>            
          </td>
          <td class="small-font">
            <span class="ui-column-title">Comments</span>
            {{item.comments}}
          </td>
          <td class="small-font">
            <span class="ui-column-title">Approver Comments</span>
            {{item.approverComments}}
          </td>
          <td>
            <span class="ui-column-title">Last Modified</span>
            {{(item.lastModified | date: 'MM/dd/yyyy') || ''}}
          </td>
          <td class="small-font">
            <span class="ui-column-title">Recent Changes</span>
            <div *ngFor="let x of splitChanges(item.recentChangesMade)">
              <p class="changes-view">{{x}}</p>
            </div>
          </td>
          <td>
            <span class="ui-column-title">Date Submitted</span>
            {{(item.dateSubmitted | date: 'MM/dd/yyyy') || ''}}
          </td>
          <td>
            <span class="ui-column-title">Status</span>
            <span *ngIf="item.approved == false && item.denied == false">Pending</span>
            <span *ngIf="item.approved">Approved</span>
            <span *ngIf="item.denied">Denied</span>
          </td>
          <td>
            <span class="ui-column-title">Action</span>
            <button class="btn btn-link mr-1" *ngIf="canEdit && item.approved === false && item.denied === false" (click)="approveTimeOffRequest(item)" title="Approve - No Comments">
              <i class="fas fa-check-circle" style="color: green;"></i>
            </button>
            <button class="btn btn-link mr-1" *ngIf="canEdit && item.approved === false && item.denied === false" (click)="denyTimeOffRequest(item)" title="Deny - No Comments">
              <i class="fas fa-ban" style="color: red;"></i>
            </button>
            <button class="btn btn-link mr-1" *ngIf="canEdit && item.approved === false && item.denied === false" (click)="commentTimeOffRequest(item)" title="Comment and More Info">
              <i class="fas fa-comment-dots"></i>
            </button>
            <button class="btn btn-link mr-1" *ngIf="canEdit && (item.approved === true || item.denied === true)" (click)="resetTimeOffRequest(item)" title="Reset Approval">
              <i class="fas fa-undo"></i>
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorleft" let-state>
          Showing {{ state.first + 1 }} - {{ (state.first + state.rows) > state.totalRecords ? state.totalRecords : (state.first + state.rows) }} of {{ state.totalRecords }} entries
      </ng-template>
      <ng-template pTemplate="paginatorright">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
                <span style="color: #495057; font-size: 14px; white-space: nowrap;">Rows per page:</span>
                <p-dropdown 
                    [options]="dropdownOptions()" 
                    optionLabel="label" 
                    optionValue="value"
                    [ngModel]="myTable.rows" 
                    [ngModelOptions]="{standalone: true}"
                    (onChange)="myTable.rows = $event.value; myTable.reset()">
                </p-dropdown>
            </div>
      </ng-template>
    </p-table>
  </div>
</form>

<app-edit-timeoff-request></app-edit-timeoff-request>
<app-approve-timeoff-request></app-approve-timeoff-request>
